import React from 'react';
import { motion } from 'framer-motion';
import './Button.css';

export default function Button({
  children,
  onClick,
  type = 'button',
  variant = 'primary', // primary, secondary, glass, dark
  size = 'md', // sm, md, lg
  className = '',
  disabled = false,
  icon: Icon = null,
  iconPosition = 'right'
}) {
  return (
    <motion.button
      whileHover={disabled ? {} : { scale: 1.02 }}
      whileTap={disabled ? {} : { scale: 0.98 }}
      type={type}
      onClick={onClick}
      className={`btn btn-${variant} btn-${size} ${className}`}
      disabled={disabled}
    >
      {Icon && iconPosition === 'left' && <Icon size={size === 'sm' ? 16 : 18} className="btn-icon-el" />}
      <span>{children}</span>
      {Icon && iconPosition === 'right' && <Icon size={size === 'sm' ? 16 : 18} className="btn-icon-el" />}
    </motion.button>
  );
}
